import { render } from "./MsPagination.vue?vue&type=template&id=864756d4"
import script from "./MsPagination.vue?vue&type=script&lang=js"
export * from "./MsPagination.vue?vue&type=script&lang=js"

import "./MsPagination.vue?vue&type=style&index=0&id=864756d4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__